export const STATUS_COLORS = {
    pending: 'default',
    in_progress: 'warning',
    completed: 'success',
    cancelled: 'error'
};

export const STATUS_LABELS = {
    pending: 'Pending',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled'
};
